<script setup lang="ts">
import { computed } from 'vue'
import { RouterView, useRoute } from 'vue-router'

import ConsoleLayout from '@/layouts/ConsoleLayout.vue'

const route = useRoute()

/**
 * Space routes render inside the console shell; the landing and onboarding
 * screens are standalone. Chosen here rather than with nested routes because
 * both surfaces want the `/` path on their own host.
 */
const inConsole = computed(() => route.meta.scope === 'space')
</script>

<template>
  <ConsoleLayout v-if="inConsole">
    <RouterView />
  </ConsoleLayout>
  <RouterView v-else />
</template>
